import { useCallback } from 'react';

import { useCookieStore } from '@uncinc/uncinc-react-kitchen-sink';
import { COOKIE_CONSENT_STATE } from '@uncinc/uncinc-react-kitchen-sink/dist/components/GoogleConsentCookieBanner';
import { LocalConsentStatus } from '@uncinc/uncinc-react-kitchen-sink/dist/components/GoogleConsentCookieBanner/types';

/**
 * Local cookie hook for using cookie consent actions from kitchen sink.
 *
 * @returns {Object}
 * Cookie methods:
 * - updateConsent: puts cookie in editing mode and shows cookie banner to the user.
 */
const useCookie = () => {
  const [, setConsent] = useCookieStore(COOKIE_CONSENT_STATE);

  const updateConsent = useCallback(() => {
    setConsent(JSON.stringify({
      status: LocalConsentStatus.STATUS_EDITING,
      version: '1.0.0',
    }));
  }, [setConsent]);

  return {
    updateConsent,
  };
};

export default useCookie;
